import { render } from "./search.vue?vue&type=template&id=72261740&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"

import "./search.vue?vue&type=style&index=0&id=72261740&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-72261740"

export default script